import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    imports: [NgFor, NgIf]
})
export class ProgressBarComponent {
  @Input() value: any = [];
  hoveredData: any = null;
  tooltipX = 0;
  tooltipY = 0;

  showTooltip(data: any, event: MouseEvent) {
    this.hoveredData = data;
  
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const tooltipWidth = 270;
    const tooltipHeight = 100; // Approximate height of the tooltip
  
    // Position from bottom-left of the cursor
    this.tooltipX = event.clientX - tooltipWidth + 10; // Start from bottom left
    this.tooltipY = event.clientY + 10; // Below the cursor
  
    // Ensure the tooltip doesn't overflow the viewport horizontally
    if (this.tooltipX < 0) {
      this.tooltipX = 10; // Prevent overflow on the left
    } else if (event.clientX + 10 > screenWidth) {
      this.tooltipX = screenWidth - tooltipWidth - 10; // Prevent overflow on the right
    }
  
    // Ensure the tooltip doesn't overflow the viewport vertically
    if (event.clientY + tooltipHeight + 10 > screenHeight) {
      this.tooltipY = screenHeight - tooltipHeight - 10; // Adjust if it goes beyond the bottom
    }
  }

  hideTooltip() {
    this.hoveredData = null;
  }
  getKeys(key){
    return Object.keys(key)
  }
}